module.exports = __webpack_public_path__ + "img/logo-group.cf719c3c.svg";